import { createSelector } from 'reselect'

const productsSelector = planning => planning.products

const isSelected = product => product.selected
export const selectedProducts = createSelector(
  productsSelector,
  products => products.filter(isSelected)
)
